<template>
  <div class="page-wrapper">
    <LoadingPlugin
      :active.sync="isLoading"
      :is-full-page="fullPage"
      background-color="#f3f3f3"
      :opacity="0.8"
      loader="bars"
    ></LoadingPlugin>

    <!-- Add Item Modal -->
    <AdditemModal
      :show="showAddItem"
      :onCancel="closeAddItem"
      @add-item="addItem"
      v-if="showAddItem"
      :item-data="item"
      @edit-item="updateEditItem"
    />

    <!-- Drop off modal -->
    <add-drop-off-modal
      :show="showAddDropOff"
      :onCancel="closeAddDropOff"
      v-if="showAddDropOff"
      :dropOffData="dropOff"
      @add-dropOff="addDropOff"
      @edit-dropOff="editDropOff"
      @open-contact="openContact"
      :items="availableItems"
      :initialValues="dropOff"
    />

    <!-- Add Contact Modal -->
    <add-contact-modal
      :show="showAddContact"
      :onCancel="closeAddContact"
      @addContact="addContact"
      :items="availableItems"
      :initialValues="dropOff"
      v-if="showAddContact"
    />

    <div class="page-breadcrumb">
      <div class="row">
        <div class="col-md-5 align-self-center mb-2">
          <h6 class="font-16 font-weight-bold">
            {{ $t("new_dispatch") }}
          </h6>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="card">
        <div class="card-body add-dispatch-container">
          <div class="mb-3">
            <Stepper :step="step" :labels="labels" />
          </div>
          <div class="d-flex align-items-center justify-content-between mb-4">
            <p
              :class="{
                'font-bold': step === 4,
              }"
            >
              {{ currentStep }}
            </p>
            <div
              class="cursor-pointer d-flex justify-content-center align-items-center"
              @click="handleAddBtn"
              v-if="showAddBtn"
            >
              <icon-circle-add class="mr-2" />
              <span class="text-primary text-capitalize">
                {{ step === 1 ? $t("add-item") : $t("add_dropoff") }}
              </span>
            </div>
          </div>

          <items-details-step
            :items="items"
            @showAddItemModal="openAddItem"
            @edit_item="editItem"
            @delete_item="deleteItem"
            v-if="step === 1"
          />

          <device-step
            v-if="step === 2"
            ref="deviceStep"
            :initialValues="deviceData"
          />

          <pickup-details-step
            ref="pickupStep"
            v-if="step === 3 && !isDropOff"
            :initialValues="pickupData"
          />

          <drop-off-step
            v-if="step === 3 && isDropOff"
            :dropOffs="dropOffs"
            @showAddDropOffModal="showAddDropOff = true"
            @edit_dropOff="editDropOffTable"
            @delete_dropOff="dropOffs.splice($event, 1)"
          />

          <Summary
            v-if="step === 4"
            :pickupDetails="[pickupData]"
            :dropOffs="dropOffs"
            @edit_pickup="edit_pickup"
            :summaryPrices="summaryPrices"
            :dropOffTableData="dropOffTableData"
            @edit_dropOff="editDropOffTable"
            @delete_dropOff="dropOffs.splice($event, 1)"
            @edit_item="openSummaryItem"
            @delete_item="deleteSummaryItem"
          />

          <div
            class="d-flex align-items-start justify-content-end col-gap-1 pt-4"
          >
            <button class="btn btn-secondary text-capitalize" @click="goBack">
              {{ $t("back_") }}
            </button>

            <button @click="goNext" class="btn btn-primary">
              {{ $t("next") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingPlugin from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Stepper from "@/components/Stepper.vue";
import ItemsDetailsStep from "./ItemsDetailsStep.vue";
import AdditemModal from "./AdditemModal.vue";
import IconCircleAdd from "../../../components/Iconsvg/IconCircleAdd.vue";
import DeviceStep from "./DeviceStep.vue";
import PickupDetailsStep from "./PickupDetailsStep.vue";
import AddDropOffModal from "./AddDropOffModal.vue";
import DropOffStep from "./DropOffStep.vue";
import AddContactModal from "./AddContactModal.vue";
import Summary from "./Summary.vue";
import { mapActions } from "vuex";
import moment from "moment";

export default {
  name: "AddDispatch",
  components: {
    Stepper,
    LoadingPlugin,
    ItemsDetailsStep,
    AdditemModal,
    IconCircleAdd,
    DeviceStep,
    PickupDetailsStep,
    AddDropOffModal,
    DropOffStep,
    AddContactModal,
    Summary,
  },
  mounted() {
    this.getContacts(this.params).then(() => {
      this.isLoading = false;
    });
    this.fetchallDevices();
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      step: 1,
      labels: [
        this.$t("item_details"),
        this.$t("device_settings"),
        this.$t("pickup_details"),
        this.$t("summary"),
      ],
      items: [],
      showAddItem: false,
      item: {},
      editIndex: null,
      dropOffs: [],
      isDropOff: false,
      showAddDropOff: false,
      dropOff: {},
      contact: {},
      showAddContact: false,
      deviceData: null,
      pickupData: null,
      summaryPrices: {},
    };
  },
  computed: {
    showAddItemBtn() {
      return this.step === 1 && this.items.length > 0;
    },
    showAddDropOffBtn() {
      return this.step === 3 && this.isDropOff && this.dropOffs.length > 0;
    },
    showAddBtn() {
      return this.showAddItemBtn || this.showAddDropOffBtn;
    },
    currentStep() {
      let stepTitle = "";
      if (this.step === 1) {
        stepTitle = this.$t("item_details");
      } else if (this.step === 2) {
        stepTitle = this.$t("device_settings");
      } else if (this.step === 3 && !this.isDropOff) {
        stepTitle = this.$t("pickup_details");
      } else if (this.step === 3 && this.isDropOff) {
        stepTitle = this.$t("dropoff_details");
      } else if (this.step === 4) {
        stepTitle = this.$t("summary");
      }

      return stepTitle;
    },
    availableItems() {
      const dropOffItems = this.dropOffs.reduce((acc, dropOff) => {
        return acc.concat(dropOff.items);
      }, []);

      return this.items.filter((item) => {
        return !dropOffItems.some(
          (dropOffItem) => dropOffItem.name === item.name
        );
      });
    },
    transformedDropOffs() {
      return this.dropOffs.flatMap((dropOff) => {
        return dropOff.items.map((item) => {
          return {
            item,
            contact: dropOff.contact,
            contactId: dropOff.contact.id || null,
          };
        });
      });
    },

    // Data for payload
    dropOffPayload() {
      const { device, ...rest } = this.deviceData;
      const { phoneNumber, ...pickupDetails } = this.pickupData;
      const formattedData = this.transformedDropOffs.map(
        ({ item, contactId, contact }) => {
          const newObject = {
            item: {
              ...item,
              deliveryDate: moment(item.deliveryDate).toISOString(),
            },
          };
          if (contactId) {
            newObject.contactId = contactId;
          } else {
            newObject.contact = contact;
          }
          return newObject;
        }
      );
      const payload = {
        dataLogger: device,
        dataLoggerSettings: rest,
        pickup: {
          phone: phoneNumber,
          ...pickupDetails,
        },
        dropoff: formattedData,
      };
      return payload;
    },

    // Data for table
    dropOffTableData() {
      return this.transformedDropOffs.map(({ item, contact }) => {
        return {
          item,
          contact,
        };
      });
    },
  },
  methods: {
    ...mapActions([
      "getContacts",
      "addOrder",
      "validateOrder",
      "fetchallDevices",
    ]),
    goBack() {
      if (this.step === 1) return this.$router.push("/dispatch/overview");

      if (this.step === 3 && this.isDropOff) {
        this.isDropOff = false;
      } else {
        this.step = this.step - 1;
      }
    },
    goNext() {
      if (this.step === 4) {
        return this.confirmOrder();
      } else if (this.step === 2) {
        const isValid = this.$refs.deviceStep.validateForm();
        if (isValid) {
          this.deviceData = this.$refs.deviceStep.getFormData();
          this.step += 1;
          this.isDropOff = false;
        }
      } else if (this.step === 3 && !this.isDropOff) {
        const isValid = this.$refs.pickupStep.validateForm();
        if (isValid) {
          this.pickupData = this.$refs.pickupStep.getFormData();
          this.isDropOff = true;
        }
      } else {
        this.step += 1;
      }
      if (this.step === 4) {
        this.doValidaOrder();
      }
    },
    goStep(step) {
      this.step = step;
    },
    addItem(item) {
      const id = this.items.length + 1;
      this.items.push({ ...item, id });
      this.showAddItem = false;
    },
    closeAddItem() {
      this.showAddItem = false;
    },
    openAddItem() {
      this.showAddItem = true;
    },
    editItem(item) {
      this.showAddItem = true;
      this.item = item;
    },
    deleteItem(index) {
      this.items.splice(index, 1);
    },
    updateEditItem(item) {
      this.$set(this.items, item.id - 1, item);
      this.item = {};
      this.showAddItem = false;
      this.editIndex = null;
    },
    handleAddBtn() {
      if (this.showAddItemBtn) {
        this.openAddItem();
      }
      if (this.showAddDropOffBtn) {
        this.showAddDropOff = true;
      }
    },
    addDropOff(dropOff) {
      this.dropOffs.push(dropOff);
      this.showAddDropOff = false;
      this.dropOff = {};
    },
    editDropOff(dropOff) {
      this.$set(this.dropOffs, this.editIndex, dropOff);
      this.showAddDropOff = false;
      this.editIndex = null;
      this.dropOff = {};
    },
    closeAddDropOff() {
      this.showAddDropOff = false;
      this.dropOff = {};
    },
    closeAddContact() {
      this.showAddContact = false;
      this.dropOff = {};
    },
    addContact(payload) {
      if (this.editIndex !== null) {
        this.$set(this.dropOffs, this.editIndex, payload);
        this.editIndex = null;
        this.showAddContact = false;
        this.dropOff = {};
        return;
      }
      this.dropOffs.push(payload);
      this.showAddContact = false;
      this.dropOff = {};
    },
    editDropOffTable(data, index) {
      this.dropOff = data;
      this.editIndex = index;
      if (data.contact.id) {
        this.showAddDropOff = true;
      } else {
        this.showAddContact = true;
      }
    },
    openContact() {
      this.showAddContact = true;
      this.showAddDropOff = false;
    },
    edit_pickup(data) {
      this.pickupData = data;
      this.isDropOff = false;
      this.step = 3;
    },
    confirmOrder() {
      this.isLoading = true;
      this.addOrder(this.dropOffPayload)
        .then(() => {
          this.isLoading = false;
          this.$router.push(`/dispatch/overview`);
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    openSummaryItem(selectedItem) {
      const foundIndex = this.items.findIndex(
        (item) => item.name === selectedItem.name
      );
      if (foundIndex !== -1) {
        this.item = this.items[foundIndex];
        this.editIndex = foundIndex;
        this.showAddItem = true;
      }
    },
    deleteSummaryItem(selectedItem) {
      this.dropOffs.forEach((dropOff) => {
        const itemIndex = dropOff.items.findIndex(
          (dropOffItem) => dropOffItem.id === selectedItem.id
        );
        if (itemIndex !== -1) {
          this.$delete(dropOff.items, itemIndex);
        }
      });
    },
    doValidaOrder() {
      this.isLoading = true;
      this.validateOrder(this.dropOffPayload)
        .then((res) => {
          this.summaryPrices = res.data.payload;
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },
  },
  watch: {
    items: {
      handler(newItems) {
        newItems.forEach((newItem) => {
          this.dropOffs.forEach((dropOff) => {
            const itemIndex = dropOff.items.findIndex(
              (dropOffItem) => dropOffItem.id === newItem.id
            );
            if (itemIndex !== -1) {
              this.$set(dropOff.items, itemIndex, newItem);
            }
          });
        });
      },
      deep: true,
    },
    dropOffs: {
      handler() {
        if (this.step === 4) this.doValidaOrder();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
@media (min-width: 768px) {
  .add-dispatch-container {
    padding: 20px 2rem;
  }
}

@media (min-width: 1600px) {
  .add-dispatch-container {
    padding: 40px 3rem;
  }
}
</style>
